"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearch = void 0;
var _react = require("react");
var _functions = require("../../../page-body/site-search-results/utils/functions");
var _unifiedSearchMapper = _interopRequireDefault(require("../unified-search-mapper"));
var _searchContext = require("./search-context");
/**
 * Utility function to parse IA markdown content
 * @param {string} markdownContent - The markdown content to parse
 * @returns {string} Parsed markdown content
 */
const parseIaMarkdown = markdownContent => {
  if (markdownContent) {
    return markdownContent.replace(/\\n/g, '\n');
  }
};

/**
 * Utility function to get available tag list from rendered tiles
 * @param {Array} renderedTiles - Array of rendered tiles
 * @returns {Array} Array of available tags
 */
const getAvailableTagList = renderedTiles => {
  if (!renderedTiles) return;
  const tilesTags = renderedTiles?.map(tile => tile.trackTag);
  const tagMap = new Map();
  for (const tag of tilesTags) {
    if (tag?.length > 0) {
      const existingTag = tagMap.get(tag);
      if (existingTag) {
        tagMap.set(tag, {
          ...existingTag,
          frequency: existingTag.frequency + 1
        });
      } else {
        tagMap.set(tag, {
          text: tag,
          frequency: 1
        });
      }
    }
  }
  const tagsOrderedByFrequency = [...tagMap].sort((a, b) => {
    return b[1].frequency - a[1].frequency;
  });
  const tags = tagsOrderedByFrequency.map(([key, value]) => ({
    key,
    value: value.text
  }));
  return tags;
};

/**
 * Search callback for performing search operations
 * @returns {Function} Search callback function
 */
const useSearch = () => {
  const {
    resultsEndpoint,
    fuzzy,
    helpSource,
    source,
    setIsLoading,
    setResults,
    setMarkdown,
    setAvailableTags,
    appKeyHeader
  } = (0, _searchContext.useInternalSearch)();
  return (0, _react.useCallback)(async (keyword, abortController) => {
    setIsLoading(true);
    let data = null;
    try {
      const apiUrl = new URL(resultsEndpoint);
      apiUrl.searchParams.set('q', (0, _functions.sanitizeDomainQuery)(keyword));
      const res = await fetch(apiUrl.href.replaceAll('%3D', '='), {
        method: 'GET',
        signal: abortController?.signal || null,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Key': appKeyHeader
        }
      });
      if (res.status === 302) {
        window.location.href = `/${res.headers.location}`;
      }
      data = await res.json();
    } catch (err) {
      if (err.name === 'AbortError') {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
    const unifiedSearchTiles = data?.results?.map(d => new _unifiedSearchMapper.default(d));
    setResults(unifiedSearchTiles);
    setMarkdown(parseIaMarkdown(data?.aiSearch?.markdown));
    const tagList = getAvailableTagList(unifiedSearchTiles);
    setAvailableTags(tagList);
    setIsLoading(false);
  }, [resultsEndpoint, fuzzy, helpSource, source, setIsLoading, setResults, setMarkdown, setAvailableTags]);
};
exports.useSearch = useSearch;